import axiosInstance from "../config/API";

const API_ENDPOINT = "/user.php";

// Fetch all users
export const fetchUsersApi = async (searchText = "") => {
  const payload = {
    search_text: searchText,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("fetch users:", response.data.body.user);
  return response.data.body.user || [];
};

// Generate user_no based on name
export const generateUserNoApi = async (name) => {
  const payload = {
    generate_user_no: true,
    name,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("generate user_no:", response.data);
  return response.data.body.user_no || "";
};

// Add a new user
export const addUserApi = async (userData) => {
  const payload = {
    name: userData.name,
    user_no: userData.user_no,
    phone_number: userData.phone_number,
    role: userData.role,
    password: userData.password,
    current_user_id: userData.current_user_id,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("add user:", response.data);
  return response.data;
};

// Update a user
export const updateUserApi = async (userData) => {
  const payload = {
    name: userData.name,
    user_no: userData.user_no,
    phone_number: userData.phone_number,
    role: userData.role,
    password: userData.password,
    current_user_id: userData.current_user_id,
    edit_user_id: userData.user_id,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("update user:", response.data);
  return response.data;
};

// Delete a user
export const deleteUserApi = async (userId, currentUserId) => {
  const payload = {
    delete_user_id: userId,
    current_user_id: currentUserId,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("delete user:", response.data);
  return response.data;
};
